export const LOGIN_CONFIRMED_ACTION = '[login action] confirmed login';
export const LOGIN_FAILED_ACTION = '[login action] failed login';
export const LOADING_TOGGLE_ACTION = '[Loading action] toggle loading';
export const LOGOUT_ACTION = '[Logout action] logout action';
export const USER_ROLE_SLUG_LOADING = '[user role slug] loading';
export const USER_ROLE_SLUG_SUCCESS = '[user role slug] success';
export const USER_ROLE_SLUG_FAILURE = '[user role slug] failure';
export const UPDATE_AUTH_USER = '[auth user] update';